export default "__VITE_ASSET__tWNL66hw__"